import React from "react";
import Table from "../../../components/table/Table";
import { useApiClient } from "../../../shared/customHooks";
import { PageHeader } from "../../../components/header/PageHeader";
import CreateApplicationButtonsManager from "../../../components/CreateApplicationButtonsManager";
import { presubmissionListTable, presubmissionTableOptions } from "../../../shared/tableObjects/admin/presubmissionListTable";

export default function PresubmissionList() {
  const apiClient = useApiClient("BaseApplication");
  const headerText = [
    {
      class: "p-0 m-0 flex align-center",
      value: "List of Presubmission Applications",
      icon: "list-icon",
    },
  ];
  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table">
        <CreateApplicationButtonsManager />{" "}
        <Table apiClient={apiClient} label={""} columns={presubmissionListTable("presubmission")} tableOptions={presubmissionTableOptions} />
      </div>
    </>
  );
}
